import { Button } from "@/components/ui/button";
import { CloseFilled } from "@carbon/icons-react";
import { FolderTrashMenuActions } from "../../constants/lib.constants";

export interface IFolderMenuItemProps {
  key: FolderTrashMenuActions;
  label: string;
  icon: React.ElementType;
}
interface IFolderMenusProps {
  items: IFolderMenuItemProps[];
  onClick: (action: FolderTrashMenuActions) => void;
}

export default function FolderMenus({ items, onClick }: IFolderMenusProps) {
  return (
    <div className="flex flex-row justify-between border-b-[1px] sticky top-0 bg-white z-[10] w-full">
      <div className="flex flex-row items-center space-x-4 p-4 overflow-x-auto">
        {items.map((item) => (
          <Button
            key={item.key}
            size="sm"
            variant="ghost"
            className="text-black bg-transparent"
            onClick={() => onClick?.(item.key)}
          >
            <item.icon className="mr-2 h-4 w-4" /> {item.label}
          </Button>
        ))}
      </div>
      <div className="flex flex-row items-center text-primary pr-5">
        <Button
          variant="ghost"
          className="rounded-full bg-transparent"
          onClick={() => onClick?.(FolderTrashMenuActions.DeSelect)}
        >
          <CloseFilled className="text-primary" />
        </Button>
        <span className="text-sm whitespace-nowrap">1 Được chọn</span>
      </div>
    </div>
  );
}
